export default "__VITE_ASSET__asxN7kqJ__"